export default __webpack_public_path__ + "static/media/uploadTw3.d48a3fe2.png";